import { Popover } from 'bootstrap';

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
popoverTriggerList.forEach(
  (popoverTriggerEl) =>
    new Popover(
      popoverTriggerEl,
      { sanitize: false } // to allow svgs in popovers
    )
);
